import React, { useEffect } from 'react';
import Participant from '../Participant/Participant';
import { styled } from '@material-ui/core/styles';
import useParticipants from '../../hooks/useParticipants/useParticipants';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import useSelectedParticipant from '../VideoProvider/useSelectedParticipant/useSelectedParticipant';
import useLocalAudioToggle from '../../hooks/useLocalAudioToggle/useLocalAudioToggle';
import { useAppState } from '../../state';
import { MESSAGE_TYPES } from '../../constants';

const Container = styled('aside')(({ theme }) => ({
    padding: '0.5em',
    overflowY: 'auto',
    [theme.breakpoints.down('xs')]: {
        overflowY: 'initial',
        overflowX: 'auto',
        padding: 0,
        display: 'flex',
    },
}));

const ScrollContainer = styled('div')(({ theme }) => ({
    [theme.breakpoints.down('xs')]: {
        display: 'flex',
    },
}));

export default function ParticipantStrip() {
    const {
        room: { localParticipant }, room, localTracks
    } = useVideoContext();

    const participants = useParticipants();
    const [selectedParticipant, setSelectedParticipant] = useSelectedParticipant();
    const { setMySid, setIsAdminMute, signOut, setIsAdmin } = useAppState();
    const [, toggleAudioEnabled, disableAudio, enableAudio] = useLocalAudioToggle();


    useEffect(() => {
        //console.log("my sid:" + localParticipant?.sid);
        setMySid(localParticipant?.sid);

        const logMsg = (s:string) => {
            //console.log(s);
        }
        const handleSignOut = () => {
            room.disconnect?.();
            localTracks.forEach(track => { if (track.kind !== 'data') { track.stop(); } });
            signOut?.();
        };
        
        room.on('trackSubscribed', function (track) {
            track.on('message', function (message) {
                var j = JSON.parse(message);
                // console.log(message); // { x: <number>, y: <number> }
                if (j.sid === localParticipant?.sid || j.sid === '') {
                    if (j.type === MESSAGE_TYPES.EJECT) {
                        logMsg("I've been ejected");
                        handleSignOut();
                    } else if (j.type === MESSAGE_TYPES.MUTE) {
                        logMsg("disable audio");
                        disableAudio();
                        setIsAdminMute(true);
                    } else if (j.type === MESSAGE_TYPES.UNMUTE) {
                        logMsg("enable audio");
                        enableAudio();
                        setIsAdminMute(false);
                    } else if (j.type === MESSAGE_TYPES.TOGGLE_MUTE) {
                        logMsg("toggle mute");
                        toggleAudioEnabled();
                    } else if (j.type === MESSAGE_TYPES.RECORDING_STARTED) {
                        logMsg('Recording has started');
                    }
                    else if (j.type === MESSAGE_TYPES.RECORDING_STOPPED) {
                        logMsg('Recording has stopped');
                    }
                    else if (j.type === MESSAGE_TYPES.PROMOTE_USER) {
                        setIsAdmin(true);
                    }


                    //logMsg("This message is for me");
                }
            });
        });
        /*
        room.on("recordingStarted", () => {
            console.log('Recording has started');
        });

        room.on("recordingStopped", () => {
            console.log('Recording has stopped');
        });*/
    }, []);

    //setMySid(localParticipant?.sid);
    /*
    */

    return (
        <Container>
            <ScrollContainer>
                <Participant
                    participant={localParticipant}
                    isLocal={true}
                    isSelected={selectedParticipant === localParticipant}
                    onClick={() => setSelectedParticipant(localParticipant)}
                />
                {participants.map(participant => (
                    <Participant
                        key={participant.sid}
                        isLocal={false}
                        participant={participant}
                        isSelected={selectedParticipant === participant}
                        onClick={() => setSelectedParticipant(participant)}
                    />
                ))}
            </ScrollContainer>
        </Container>
    );
}
